// 下载文件选择是否高亮和格式
<template lang="pug">
div.download-type-wrapper
  div.container
    div.head-area
      i.close-icon(@click="close")
      h1 选择译文类型
    div.main-area
      .item-wrapper
        label.item-label(
          :class="{isRequied: true}"
        ) 译文格式
        <el-radio v-model="downloadFileType" label="origin" >{{ fileType | formartText}}</el-radio>
        <el-radio v-model="downloadFileType" label="pdf" :disabled="isDisablePDF">PDF</el-radio>
      .item-wrapper(
        v-if="isShowHightLightProp && (fileType !== 'txt' || (downloadFileType === 'pdf'))"
      )
        label.item-label(
          :class="{isRequied: true}"
        ) 术语高亮
        el-switch(
          v-model="isHightLight"
        )

    div.confirm-btn(
      @click="confirm"
    ) 确定
</template>
<script>
export default {
  name: 'add-entry',
  props: {
    isShowHightLightProp: {
      type: Boolean,
      default: false
    },
    // isHightLightProp: {
    //   type: Boolean,
    //   default: true
    // },
    isDisablePDF: {
      type: Boolean,
      default: true
    },
    fileType: {
      type: String,
      default: ''
    }
  },
  filters: {
    formartText(value) {
      if (!value) {
        return '原文档格式'
      }
      value = value.toUpperCase()
      const formatList = {
        DOCX: 'Word',
        DOC: 'Word',
        PDF: 'Word',
        PPT: 'PPT',
        PPTX: 'PPT'
      }
      return formatList[value] || value
    }
  },
  data() {
    return {
      downloadFileType: 'origin',
      isHightLight: true
    }
  },
  computed: {},
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      if (!this.isShowHightLightProp) this.isHightLight = null
      let downloadFileType = this.downloadFileType
      if (this.fileType.toUpperCase() === 'PDF' && this.downloadFileType === 'origin') {
        downloadFileType = 'word'
      }
      this.$emit('okCb', downloadFileType, this.isHightLight)
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin signCommon($c: #ff6583, $fs: 13px) {
  position: absolute;
  top: 2px;
  left: 0;
  content: '*';
  color: $c;
  font-size: $fs;
}

.download-type-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(18, 27, 52, 0.5);
  z-index: 1000;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    // height: 204px;
    padding: 0 24px;
    background: #ffffff;
    border-radius: 8px;
    &.container-large {
      height: 302px;
    }
  }
  .head-area {
    position: relative;
    margin-top: 16px;
    margin-bottom: 24px;
    h1 {
      @include fontStyle(15px, 600, #2e2f33, 22px);
      margin-bottom: 4px;
    }
    p {
      @include fontStyle(13px, 500, #909299, 20px);
    }
  }
  .close-icon {
    position: absolute;
    top: 0;
    right: -5px;
    display: block;
    width: 16px;
    height: 16px;
    background: url('../../assets/img/ic_popup_close_normal.png') no-repeat;
    background-size: 100%;
    cursor: pointer;
  }
  .main-area {
    // @include flexCommon();
    .item-wrapper {
      margin-bottom: 25px;
      &,
      * {
        box-sizing: border-box;
      }
      // display: table;
      height: 18px;
      line-height: 18px;
      .item-label {
        width: 64px;
        padding-left: 10px;
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        margin-right: 28px;
        text-align: left;

        position: relative;
        &.isRequied {
          &::before {
            @include signCommon();
          }
        }
      }
    }
  }
  .original {
    margin-right: 20px;
  }
  .title {
    position: relative;
    @include fontStyle(13px, 500, #2e2f33, 15px);
    padding-left: 13px;
    margin-bottom: 6px;
    &::before {
      @include signCommon();
    }
  }
  .el-textarea {
    height: 84px;
  }
  .prompt-area {
    position: relative;
    margin-top: 8px;
    @include flexCommon(flex, space-between);
    .tips {
      position: relative;
      width: 163px;
      @include fontStyle(13px, 500, #909299);
      padding-left: 13px;
      &::before {
        @include signCommon(#909299);
      }
    }
    .waring-tips {
      font-size: 11px;
      position: absolute;
      top: 24px;
      color: #ff6583;
    }
  }
  .el-checkbox {
    width: 176px;
  }
  .confirm-btn {
    float: right;
    width: 90px;
    height: 32px;
    @include fontStyle(13px, 500, #c4c6cc, 32px);
    background: #ebecf0;
    text-align: center;
    border-radius: 16px;
    margin-bottom: 24px;
    cursor: pointer;
    color: #ffffff;
    background: $normalC;
    // position: absolute;
    // right: 24px;
    // bottom: 24px;
    &:hover {
      background: $hoverC;
    }
  }
}
</style>
